/**
 * BrandHeader Component
 *
 * Displays the brand logo and name for the authentication page.
 * Used consistently across all auth-related interfaces.
 */

import { useTranslation } from 'react-i18next';

interface BrandHeaderProps {
  readonly className?: string;
}

const BrandHeader = ({ className = '' }: BrandHeaderProps) => {
  const { t } = useTranslation('auth');
  return (
    <div className={`flex items-center gap-2 p-2 ${className}`}>
      <img
        alt="Public Pulse"
        className="size-8.5 object-contain"
        src="/svg/public-pulse-logo.svg"
      />
      <span className="text-lg font-bold text-brand-primary">{t('brand.name')}</span>
    </div>
  );
};

export default BrandHeader;
